<app-header [showAvatar]="false" title="Security" [useTabs]="false">
</app-header>
<div class="body">
  <div class="body-container">
    <div class="page-main">
      <div class="page-container">
        <div class="form-wrapper">
          <div class="form-content">
            <div class="form-section">
              <div class="form-section-side">
                <h1 class="label-title">Authentication settings</h1>
                <!-- <p class="label-subtitle">Rebillia supports Single Sign-On (SSO) and two-factor authentication for all users.</p> -->
              </div>
              <div class="form-section-container padding nopadding">
                <div class="form-section-body">

                  <mat-card class="custom-mat-card card-form-wrapper size size1of1">
                    <mat-card-content class="card-content">
                      <div class="card-section padding nopadding">

                        <mat-list *ngIf="isDataReady" [@skeletonAnimation] class="custom-mat-list list-grid-std list-company-gateways">
                          <mat-list-item class="custom-mat-list-item grid-row">
                            <div class="row-wrapper">
                              <p class="gateway-name">Add an extra layer of security to your account by requiring your password and a personal device to log in.</p>
                            </div>
                            <mat-slide-toggle (change)="changeTwoFactorAuthentication($event)" class="custom-mat-slide-toggle align asidePos" color="primary"></mat-slide-toggle>
                          </mat-list-item>
                        </mat-list>

                        <mat-list *ngIf="!isDataReady" [@skeletonAnimation] class="custom-mat-list list-grid-std list-skeleton">
                          <mat-list-item class="custom-mat-list-item grid-row">
                            <p matLine ><skeleton-loader
                              [theme]="{'width': '80%'}"></skeleton-loader></p>
                            <button mat-icon-button ><skeleton-loader></skeleton-loader></button>
                          </mat-list-item>
                        </mat-list>

                      </div>
                    </mat-card-content>
                  </mat-card>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
